'use client';
import { posthog } from 'posthog-js';
import { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { LoadingBlockFullPage } from '../components/loading/loading-block-full-page.tsx';
import { AppProviders } from '../components/providers/app-providers.tsx';
import { ErrorBoundary } from '../features/error-boundary/error-boundary.tsx';
import { APP_ENV } from '../lib/constants.ts';
import '../styles/globals.css';

const MyApp = () => {
    const location = useLocation();

    useEffect(() => {
        if (APP_ENV === 'production') {
            const handleRouteChange = () => posthog?.capture('$pageview');
            handleRouteChange();
        }
    }, [location.pathname]);

    return (
        <ErrorBoundary>
            <AppProviders>
                <Suspense fallback={<LoadingBlockFullPage />}>
                    <Outlet />
                </Suspense>
            </AppProviders>
        </ErrorBoundary>
    );
};

export default MyApp;
